import { Component, Input, OnInit } from '@angular/core';
import { TrainerModel } from 'src/app/models/trainer.model';

@Component({
  selector: 'app-trainer-card',
  templateUrl: './trainer-card.component.html',
  styleUrl: './trainer-card.component.scss',
  standalone: false
})
export class TrainerCardComponent implements OnInit {
  @Input() trainer!: TrainerModel;
  @Input() maxNameLength: number = 20;

  @Input() avatarSize?: string;
  @Input() fontSize?: string;
  @Input() fontColor?: string;

  trainerViewModel?: TrainerViewModel;

  ngOnInit(): void {
    if (this.trainer) {
      const firstName = this.trainer.firstName || '';
      const lastName = this.trainer.lastName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      
      const firstInitial = firstName[0] || '';
      const lastInitial = lastName[0] || '';

      this.trainerViewModel = {
        name: fullName.length > this.maxNameLength 
          ? fullName.substring(0, this.maxNameLength - 3) + '...' 
          : fullName,
        fullName: fullName,
        image: this.trainer.imageFile?.fileUrl ?? null,
        initials: (firstInitial + lastInitial).toUpperCase()
      };
    }
  }
}

interface TrainerViewModel {
  name: string;
  fullName: string;
  image: string | null;
  initials: string;
}